/* eslint-disable react/no-array-index-key */
import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  // , ResponsiveContainer
} from 'recharts';

function getRandomColor() {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i += 1) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

function initBgColors() {
  const colors = [
    '#3F72E3',
    '#C0C0C0',
    '#3CB371',
    '#FFA500',
    '#DDA0DD',
    '#9932CC',
  ];
  for (let index = 0; index < 500; index += 1) {
    colors.push(getRandomColor());
  }
  return colors;
}

const COLORS = initBgColors();

const CustomPieChart = ({
  data,
  width = 400,
  height = 400,
  outerRadius = 100,
}) => {
  return (
    // <ResponsiveContainer width="100%" height="100%">
    <PieChart width={width} height={height}>
      <Pie
        data={data}
        cx="50%"
        cy="50%"
        labelLine={false}
        //   label={renderCustomizedLabel}
        outerRadius={outerRadius}
        fill="#aaa"
        dataKey="value"
      >
        {data.map((entry, index) => (
          <Cell
            key={`cell-${index}`}
            fill={entry.color || COLORS[index % COLORS.length]}
          />
        ))}
      </Pie>
      <Legend />
    </PieChart>
    // </ResponsiveContainer>
  );
};

export default CustomPieChart;
